import {Component, Inject, OnInit, OnDestroy, Input} from '@angular/core';
import {ClientService} from "../../Services/client.service";
import {Observable, Subscription, timer} from "rxjs";
import {map, take} from "rxjs/operators";
import { ProjectTheme } from "src/app/Models/ProjectTheme";

@Component({
    selector: 'app-forgot-password-popup',
    templateUrl: './forgot-password-popup.component.html',
    styleUrls: ['./forgot-password-popup.component.scss'],
    standalone: false
})
export class forgotPasswordPopupComponent implements OnInit, OnDestroy {
  /** Theme configuration for the modal components */
  theme: ProjectTheme = 'ABC';
  @Input() email!: string;      

  /** Timer observable for countdown functionality */
  timer$!: Observable<number>;

  /** Subscription for the timer observable */
  timerSub!: Subscription;
  constructor(
   
    private clientService: ClientService
  ) {}


  ngOnInit() {
    this.countDown(0);
  }

  /**
   * Closes the dialog
   */
  closeDialog(): void {
   // this.dialogRef.close();
  }

  /**
   * Resends a password reset email
   * This method can be called when a user clicks "Renvoyer le mail" in the forgot password modal
   * @param email The email address to send the reset link to
   */
  resendPasswordEmail(email: string): void {
    this.clientService.resetPasswordRequest(email).subscribe(
      () => {
        // Reset handled by the library component
      },
      () => {
        // Error handling by the library component
      }
    );
  }

  /**
   * Creates and starts a countdown timer
   * @param time The number of seconds to count down from
   */
  private countDown(time: number): void {
    this.timer$ = timer(0, 1000).pipe(
      map((i) => time - i),
      take(time + 1)
    );
    this.timerSub = this.timer$.subscribe();
  }

  /**
   * Cleanup subscriptions when component is destroyed
   */
  ngOnDestroy(): void {
    if (this.timerSub) {
      this.timerSub.unsubscribe();
    }
  }
}
